import React, { Component } from 'react';
import config from 'react-global-configuration';

import { BrowserRouter, Redirect, Route, Link } from 'react-router-dom';

// Importação do Bootstrap
import { Navbar, NavItem, Nav, MenuItem, NavDropdown } from 'react-bootstrap';

const PropTypes = require('prop-types');

class Topo extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      redirect_url: false,
      questoes_respondidas: 0,
      total_questoes: 0,
      staff_name: '',
      questoes: {},
    };
    this.logout = this.logout.bind(this);
  }

  componentDidMount() {
    var dados = localStorage.getItem("cid");
    dados = JSON.parse(dados);
    this.setState({staff_name: dados.name});
  }


  logout(event){
    localStorage.removeItem("cid");
    localStorage.removeItem("prova");
    localStorage.removeItem("verifica_mensagem");
    localStorage.removeItem("iniciada");
    var url = '/usuario/login';
    this.setState({redirect_url: url});
  }

  render() {
    return (
      <div>
        {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
        <section>
          <div className="container-fluid">
            <div className="row text-center" id="header">
              <div className="col-md-7">
                <div className="row">
                  <div className="col-md-2 link-home">
                    <i className="fa fa-home" aria-hidden="true"></i> INÍCIO
                  </div>
                  <div className="col-md-10 nav-aluno-nome">
                    <p>{this.state.staff_name}</p>
                  </div>
                </div>
              </div>
              <div className="col-md-2 margin-topo">
                <p><b>Tempo restante:</b> 00:00:00</p>
              </div>
              <div className="col-md-2 margin-topo">
                <p><b>Total de questões:</b> 0/0</p>
              </div>
              <div className="col-md-1 nav-logout text-right">
                <button onClick={this.logout} className="btn"><i className="fa fa-sign-out" aria-hidden="true"></i><br/>Logout</button>
              </div>
            </div>
          </div>
        </section>        
      </div>
    );
  }
}

Topo.contextTypes = {
  router: React.PropTypes.object.isRequired
}


export default Topo;



// WEBPACK FOOTER //
// ./src/Components/Layout/TopoEstatico.js